import type { Product } from '../pages/CatalogPage';

export type RawProduct = Record<string, unknown>;

type ApiResponse = {
  success: boolean;
  data: RawProduct[];
};

export function parseApiResponse(response: unknown): ApiResponse {
  const r = response as ApiResponse;
  return { success: !!r?.success, data: Array.isArray(r?.data) ? r.data : [] };
}

export function parseProduct(raw: RawProduct): Product {
  let countries: Record<string, boolean | string> = {};
  try {
    const rawCountries = raw.countries;
    countries =
      typeof rawCountries === 'string'
        ? JSON.parse(rawCountries)
        : (rawCountries as Record<string, boolean | string>) || {};
  } catch {
    // leave as empty object
  }

  let regions: string[] = [];
  try {
    const src = raw.available_regions ?? raw.regions;
    regions =
      typeof src === 'string'
        ? JSON.parse(src)
        : Array.isArray(src)
        ? (src as string[])
        : [];
  } catch {
    // leave as empty array
  }

  return { ...(raw as unknown as Product), countries, regions };
}

export function parseProducts(raws: RawProduct[]): Product[] {
  return raws.map(parseProduct);
}
